"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL = exports.RESUMABLE = exports.QUEUED_BULK_TASK = exports.PAUSED_BULK_TASK = exports.DECLINED_BULK_TASK = exports.FAILED_BULK_TASK = exports.DONE_BULK_TASK = exports.RUNNING_BULK_TASK = exports.PENDING_BULK_TASK = void 0;
exports.PENDING_BULK_TASK = 'PENDING';
exports.RUNNING_BULK_TASK = 'RUNNING';
exports.DONE_BULK_TASK = 'DONE';
exports.FAILED_BULK_TASK = 'FAILED';
exports.DECLINED_BULK_TASK = 'DECLINED';
exports.PAUSED_BULK_TASK = 'PAUSED';
exports.QUEUED_BULK_TASK = 'QUEUED';
exports.RESUMABLE = [exports.PENDING_BULK_TASK];
exports.ALL = [
    exports.PENDING_BULK_TASK,
    exports.RUNNING_BULK_TASK,
    exports.DONE_BULK_TASK,
    exports.FAILED_BULK_TASK,
    exports.DECLINED_BULK_TASK,
    exports.PAUSED_BULK_TASK,
];
